const GradientBadge = ({ children, width = 55, height = 33, background = '#FFFFFF' }) => {
  const styles = {
    container: {
      position: 'relative',
      width: `${width}px`,
      height: `${height}px`,
      borderRadius: '91.5px',
      overflow: 'hidden',
    },
    gradientLayer: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background: 'linear-gradient(to right, #3b6af4, #19aedf)',
      borderRadius: '91.5px',
    },
    overlayLayer: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      inset: '3px',
      backgroundColor: background,
      borderRadius: '91.5px',
    },
    textLayer: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 2,
    },
  }

  return (
    <div style={styles.container}>
      <div style={styles.gradientLayer}></div>
      <div style={styles.overlayLayer}></div>
      <div style={styles.textLayer}>{children}</div>
    </div>
  )
}

export { GradientBadge }
